
import { Modal, Select, Radio, Input, Row, Col } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchLawdocuments, hideNewLawplaceDialog, addLawPlace } from './sbtActions';
import Highlight from '../components/highlightComponent'

const RadioGroup = Radio.Group;
const { Option } = Select;

class SbtLawplaceDialogComponent extends Component {

  state = {
    query: '',
    chapter: '',
    sblDocumentId: -1,
    count: 1
  }

  componentDidMount() {
    if (!this.props.allLawPlaces) {
      this.props.dispatch(fetchLawdocuments());
    }
  }

  clearState() {
    this.setState({
      query: '',
      sblDocumentId: -1,
      count: 1
    })
  }

  onOk = () => {

    let lawplace = this.props.allLawPlaces.find(l => l.id === this.state.sblDocumentId);
    this.props.dispatch(addLawPlace(lawplace, this.state.count, this.state.chapter));

    this.clearState();

  }

  onChangeQuery(query) {
    this.setState({ query });
  }

  handleCancel = () => {
    this.props.dispatch(hideNewLawplaceDialog());
    this.clearState();
  }

  onChange(sblDocumentId) {
    this.setState({ sblDocumentId });
  }

  onChangeChapter(chapter) {
    this.setState({ chapter });
  }

  onAmountChange(count) {
    this.setState({
      count
    });
  }

  render() {

    if (!this.props.showNewLawplaceDialog) {
      return null;
    }

    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };

    const h2Style = { marginTop: 20 };

    let { query, sblDocumentId } = this.state;

    let queryLower = query.toLowerCase();

    let lpFilter = f => (f.title.length > 0 && f.title.toLowerCase().indexOf(queryLower) >= 0) 
      || (f.sfsNumber.length > 0 && f.sfsNumber.toLowerCase().indexOf(queryLower) >= 0);

    // Filter is all caps
    if(query.toUpperCase() === query){
      lpFilter = f => (f.title.length > 0 && f.title.indexOf(query) >= 0) || (f.sfsNumber.length > 0 && f.sfsNumber.indexOf(query) >= 0);
    }

    const filteredRecords = query.length > 0 ?
      [...new Set(this.props.allLawPlaces.filter(lpFilter))].slice(0, 10) :
      [];

    return (

      <Modal
        title='Nytt lagrum'
        visible={true}
        width={1200}
        maskClosable={false}
        onOk={this.onOk}
        onCancel={this.handleCancel}
        cancelButtonProps={{ style: { float: 'left' } }}
        okButtonProps={{ disabled: sblDocumentId === -1, style: { float: 'left' } }}
      >
        <div>
          <Input autoFocus onChange={(e) => this.onChangeQuery(e.target.value)} placeholder='Sök på namn eller SFS nummer...' />

          {filteredRecords.length > 0 && <div>
            <h2 style={h2Style}>Träffar</h2>
            <RadioGroup onChange={(e) => this.onChange(e.target.value)} value={this.state.sblDocumentId}>
              {filteredRecords.map((r) => (
                <Radio style={radioStyle} value={r.id} key={r.id}>
                  <Highlight text={r.title + ' (' + r.sfsNumber + ')'} query={query} />
                </Radio>
              ))}

            </RadioGroup>
          </div>}

          {sblDocumentId !== -1 && <Row>
            <Col span={6}>
              <h2 style={h2Style}>Antal rader</h2>
              <Select disabled={sblDocumentId === -1} value={this.state.count} style={{ width: 120 }} onChange={(e) => this.onAmountChange(e)} style={{ width: 200 }}>
                <Option value="1">1</Option>
                <Option value="2">2</Option>
                <Option value="3">3</Option>
                <Option value="4">4</Option>
                <Option value="5">5</Option>
                <Option value="6">6</Option>
                <Option value="7">7</Option>
                <Option value="8">8</Option>
                <Option value="9">9</Option>
                <Option value="10">10</Option>
              </Select>
            </Col>
            <Col span={6}>
              <h2 style={h2Style}>Kapitel</h2>
              <Input style={{ width: 200 }} onChange={(e) => this.onChangeChapter(e.target.value)} />
            </Col>
          </Row>}

        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showNewLawplaceDialog: state.sbt.showNewLawplaceDialog,
    allLawPlaces: state.sbt.allLawPlaces
  }
};

export default connect(mapStateToProps)(SbtLawplaceDialogComponent);


// WEBPACK FOOTER //
// ./src/sbt/sbtLawplaceDialogComponent.js